export default __webpack_public_path__ + "static/media/10.e7b682f3.png";